import i18next from 'i18next';

/**
 * Close the modal
 *
 * @returns {void}
 */
export function exitModal(setLoading, closeModal) {
  setLoading(false);

  closeModal();
}

/**
 * Set component with export success state
 *
 * @returns {void}
 */
export function exportReady(setLoading, setTitle) {
  setTitle(i18next.t('GENERAL.EXPORT_SUCCESS'));
  setLoading(false);
}

/**
 * Set component with export failure state
 *
 * @returns {void}
 */
export function exportFailure(setLoading, setTitle) {
  setTitle(i18next.t('GENERAL.EXPORT_FAILURE'));
  setLoading(false);
}
